// extracted by mini-css-extract-plugin
export default {"btn":"BtnHidden_btn__K0WLv"};